const VERBS = { create: 'created', edit: 'updated', delete: 'deleted' };

/**
 * What an Activities feed row says after the user's name.
 *
 * Opening or downloading a file is logged as a `download` row, and
 * `data.via` says which (OL-156). Those rows used to read "created the
 * invoices information" (OL-186).
 */
export const activitySentence = (activity) => {
  const type = activity?.log_type;
  const table = activity?.table_name || 'record';

  if (type === 'download') {
    const verb = activity?.data?.via === 'download' ? 'downloaded' : 'viewed';
    return `${verb} ${activity?.data?.name || `the ${table} file`}`;
  }

  // Added from the matter's stage history (OL-209).
  if (type === 'stage') {
    const { from, to } = activity?.stage_change || {};
    const target = to || 'no stage';
    return from ? `moved the matter from ${from} to ${target}` : `set the matter's stage to ${target}`;
  }

  if (type === 'delete' && table === 'invoices') {
    const number = activity?.data?.number || activity?.current_data?.number;
    return `deleted the Invoice-${number}`;
  }

  return `${VERBS[type] ?? 'updated'} the ${table} information`;
};
